import React, { useState } from "react";
import "./queryList.css";
// css comes in replyQuery.css
import ReplyQuery from "../Reply Query/ReplyQuery";
import DeleteQuery from "./DeleteQuery";
import moment from "moment";
import ResolveQuery from "./ResolveQuery";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import DeclineQuery from "./DeclineQuery";
import MideaViewer from "../../../midea_viewer/MideaViewer";
import DatePicker from "react-datepicker";
import axios from "../../../axios";
import "react-datepicker/dist/react-datepicker.css";
import Popup from "reactjs-popup";
import GroupMemberList from "../Query Header/GroupMemberList";
import assets from "../../../assets/assets";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { Tooltip } from "@mui/material";
import { shortenParagraph } from "../../../utils/Engagement";
import { LucideTag, MessageSquareMoreIcon, Paperclip } from "lucide-react";
const QueryExpand = ({
  refetch,
  change,
  setEditQueryData,
  setQuery,
  queries,
  setDelQuery,
  setExpandQuery,
  setDataFinal,
  groupData,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [option, setOption] = useState("Name");
  const [clickExpandBtn, setClickExpandBtn] = useState(true);
  const [deleteQuery, setDeleteQuery] = useState();
  const [mideaviewer, setMideaviewer] = useState(false);
  const [mideaviewerAttachment, setMideaviewerAttachment] = useState();
  const [changeStatus, setChangeStatus] = useState(false);
  const [replyfetch, setReplyFetch] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [isGettingData, setIsGettingData] = useState(false);
  const [isClearingSearch, setIsClearingSearch] = useState(false);
  const [isPreventApiCall, setIsPreventApiCall] = useState(false)

  let attachments = queries?.attachments;
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const [filter, setFilter] = useState({
    date: null,
    replyText: null,
    searchClick: null,
    page: 1,
    limit: 5,
  });
  const [reply, setReply] = useState([]);
  console.log(mideaviewer, mideaviewerAttachment);
  let userId = teacher_id;
  let user;
  if (userId === queries?.user_id?.id) {
    user = true;
  }

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();
    const hours = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const timeHelperUTC = (a) => {
    const dateObj = new Date(a);
    const updatedDateObj = new Date(
      dateObj.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
    );
    const year = updatedDateObj.getUTCFullYear();
    const month = updatedDateObj.getUTCMonth() + 1;
    const day = updatedDateObj.getUTCDate();
    const hours = updatedDateObj.getUTCHours();
    const minutes = updatedDateObj.getUTCMinutes();
    const seconds = updatedDateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setReply([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };

  const today = new Date();
  function formatDate(inputDate) {
    console.log(inputDate);
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;


    // console.log(formattedDate);
    setSelectedDate(formattedDate);
  }
  const getReplyReload = async () => {
    try {
      setIsGettingData(true)
      const response = await axios.get(`/query/reply/get/${queries?.id}?sortBy=-1`)
      response.data.data.length > 0 && setReply(response.data.data);
    } catch (error) {
      console.log(error)
    }
    setIsGettingData(false)
  }

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment)
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };


  const getAttachmentName = (attachment) => {
    let name = attachment.indexOf("_") > 0
      ? attachment.substring(attachment.indexOf("_") + 1)
      : attachment
    return name.length > 20 ? name.substring(0, 20) + "..." : name;
  }

  return (
    <>
      <div className="subjectWise_query_file_path">
        <div className="gap-2 px-2 d-flex align-items-center">
          <div className="back" onClick={() => setExpandQuery(false)}>
            <img src="/images/BackArrow.svg" alt=""></img>
          </div>
          <img
            src={
              groupData?.profile_picture
                ? IP + groupData?.profile_picture.replace(/^\./, "")
                : assets?.QueryImg
            }
            className="query_profileimg"
            alt=""
            onError={(e) => {
              e.target.src = assets?.QueryImg
            }}
          />
          <span className="query_channelName">{groupData?.name}</span>
          <div className="query_status_img">
            {/* <img
              src="/images/status circle1.svg"
              className="cicle_statusImage"
              alt=""
            /> */}

            {/* <img
              src="/images/status circle2.svg"
              className="cicle_statusImage2"
              alt=""
            /> */}
            {/* <Popup
              on="click"
              // className="completed_list"
              trigger={
                <div className="nth_person">+{groupData?.member?.length}</div>
              }
              content={
                <GroupMemberList totalMember={groupData?.member?.length} />
              }
              position=" right "
            /> */}
            {/* <div className="nth_person">+{groupData?.member?.length}</div> */}
          </div>
        </div>
      </div>

      <div
        className={`mt-4 mx-2 query_list_box orange-scrollBar ${queries?.status === "resolved"
          ? `resolveGray`
          : queries?.status === "rejected"
            ? `rejectedRed`
            : ""
          }`}
      >
        <div className="full_box_coleps">
          <div className="flex items-center">
            <div className="mr-2 d-flex">
              <span className="status_icon"></span>
              <span
                className={`mr-2 poppins-semibold  ${queries?.status === "rejected" ? "mt-0" : ""
                  } `}
              >
                {queries?.status === "pending" && (
                  <img
                    src={"/images/Pending.svg"}
                    height={70}
                    width={70}
                    alt=""
                  />
                )}
                {queries?.status === "approved" && (
                  <img
                    src={"/images/Active.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
                {queries?.status === "rejected" && (
                  <div className="">
                    <p className="rej poppins-semibold">⦿ Rejected</p>
                  </div>
                )}
                {queries?.status === "resolved" && (
                  <img
                    src={"/images/Resolved.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
              </span>
            </div>
            <span className="mr-1 status_header">{queries?.book?.name}</span>
            {queries?.book?.name && queries?.chapter?.name && (
              <span className="mx-1">{`>`}</span>
            )}
            <span className="status_header">{queries?.chapter?.name}</span>
          </div>

          <div className="w-full mt-2">
            <div className="w-full flex justify-between items-center">
              <div className="w-[96%]">
                <div
                  onClick={() =>
                    !(
                      queries?.status === "pending" ||
                      queries?.status === "rejected"
                    ) && setClickExpandBtn(!clickExpandBtn)
                  }
                  className="comments-text poppins-semibold"
                >
                  {queries?.query}
                </div>
                <div className="my-1">
                  <p
                    onClick={() =>
                      !(
                        queries?.status === "pending" ||
                        queries?.status === "rejected"
                      ) && setClickExpandBtn(!clickExpandBtn)
                    }
                    className="comments-text query_description"
                    style={{ width: "95%" }}
                  >
                    {queries?.description}
                  </p>
                </div>
              </div>
              <div className="query_time d-flex gap-2">
                {moment(queries?.updated_at).calendar({
                  sameDay: "h:mm a",
                  lastDay: "h:mm a",
                  lastWeek: "h:mm a",
                  sameElse: "h:mm a",
                })}
              </div>
            </div>
            <hr
              className="mt-1 border-3 "
              style={{
                width: "100%",
                borderBottom: "2px solid #D9D9D9",
              }}
            />
          </div>

          <div className="w-full flex justify-between items-center">
            <div className="flex gap-2 items-center">
              <div className="mr-2">
                {
                  queries?.user_id?.role === "Teacher" ?
                    <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP + queries?.user_id?.profile_picture.replace(/^\./, "")
                          : reply?.user_id?.gender === "M"
                            ? "/images/Teacher_Male.jpg"
                            : queries?.user_id?.gender === "F"
                              ? "/images/Teacher_Female.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{ width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer" }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = "/images/Teacher_Male.jpg"
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = "/images/Teacher_Female.png"
                        } else {
                          e.target.src = "/images/default image.png"
                        }
                      }}
                    /> : <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP + queries?.user_id?.profile_picture.replace(/^\./, "")
                          : queries?.user_id.gender === "M"
                            ? queries?.user_id?.avatarProfile ? '/images/Boys/' + queries?.user_id?.avatarProfile + '.webp'
                              : "/images/Student_boy_pic.png"
                            : queries?.user_id?.gender === "F"
                              ? queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp'
                                : "/images/Student_girl_pic.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{ width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer" }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        e.target.src = queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = queries?.user_id?.avatarProfile ? '/images/Boys/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                        } else {
                          e.target.src = "/images/default image.png"
                        }
                      }}
                    />
                }
              </div>
              <div>
                {user ? (
                  <span className="query_name"> you </span>
                ) : (
                  <span className="query_name"> {queries?.user_id?.name} </span>
                )}
              </div>
              <div>
                {/* {user && queries?.status === "approved" && (
                  <span
                    className="query_resolved"
                    name="resolved"
                    onClick={(e) => setMarkQuery(true)}
                  >
                    Mark as Resolved
                  </span>
                )} */}
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div
                className="flex items-center gap-2"
                style={{
                  marginRight: `${(queries?.status === "pending" ||
                    queries?.status === "rejected") &&
                    "2.5rem"
                    }`,
                }}
              >
                <LucideTag size={20} style={{ transform: "rotate(90deg)" }} />
                {queries?.tags?.map((item, index) => (
                  <span key={index} className="related_query ml-1">
                    {item}
                  </span>
                ))}
              </div>
              {attachments.length > 0 && (<div className="flex items-center gap-2">
                <Paperclip size={20} />
                {attachments.length}
              </div>)}
              <div className="flex items-center gap-2">
                <MessageSquareMoreIcon size={20} /> {queries?.reply_count}
              </div>
              <div>
                {!(
                  queries?.status === "pending" || queries?.status === "rejected"
                ) && (
                    <img
                      className={`${clickExpandBtn ? "rotate_down_arrow" : "query_down_arrow"
                        } `}
                      src="/images/Down arrow.svg"
                      alt="Expand Arrow"
                      onClick={() => {
                        setReply([]);
                        setFilter({
                          ...filter,
                          replyText: "",
                          date: "",
                          page: 1,
                        });
                        setClickExpandBtn(!clickExpandBtn);
                      }}
                    />
                  )}
              </div>
            </div>

          </div>

          {/* <div className="gap-2 d-flex align-items-center justify-content-between">
            <div className="gap-2 flex-wrap align-items-center d-flex w-50">
              <div className="gap-3  d-flex align-items-center query_info">
                <span className="total_teply">
                  {queries?.reply_count} Replies
                </span>
                {
                  queries?.user_id?.role === "Teacher" ?
                    <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP + queries?.user_id?.profile_picture.replace(/^\./, "")
                          : queries?.user_id?.gender === "M"
                            ? "/images/Teacher_Male.jpg"
                            : queries?.user_id?.gender === "F"
                              ? "/images/Teacher_Female.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{ width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer" }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = "/images/Teacher_Male.jpg"
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = "/images/Teacher_Female.png"
                        } else {
                          e.target.src = "/images/default image.png"
                        }
                      }}
                    /> : <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP + queries?.user_id?.profile_picture.replace(/^\./, "")
                          : queries?.user_id.gender === "M"
                            ? queries?.user_id?.avatarProfile ? '/images/Boys/' + queries?.user_id?.avatarProfile + '.webp'
                              : "/images/Student_boy_pic.png"
                            : queries?.user_id?.gender === "F"
                              ? queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp'
                                : "/images/Student_girl_pic.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{ width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer" }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        e.target.src = queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = queries?.user_id?.avatarProfile ? '/images/Boys/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = queries?.user_id?.avatarProfile ? '/images/Girls/' + queries?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                        } else {
                          e.target.src = "/images/default image.png"
                        }
                      }}
                    />
                }
                {user ? (
                  <span className="query_name"> you </span>
                ) : (
                  <span className="query_name"> {queries?.user_id?.name} </span>
                )}

                {queries?.status === "approved" && (
                  <span
                    className="query_resolved"
                    name="resolved"
                    onClick={(e) => setMarkQuery(true)}
                  >
                    Mark as Resolved
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex gap-4 mw-50 align-items-center justify-content-center ">
              <div
                style={{
                  marginRight: `${queries?.status === "pending" && "2.5rem"}`,
                }}
              >
                {queries?.tags?.map((item, index) => (
                  <span key={index} className="related_query ml-1">
                    {item}
                  </span>
                ))}
              </div>
              {!(
                queries?.status === "pending" || queries?.status === "rejected"
              ) && (
                  <img
                    className={`${clickExpandBtn ? "rotate_down_arrow" : "query_down_arrow"
                      } `}
                    src="/images/Down arrow.svg"
                    alt="Expand Arrow"
                    onClick={() => {
                      setReply([]);
                      setFilter({
                        ...filter,
                        replyText: "",
                        date: "",
                        page: 1,
                      });
                      setClickExpandBtn(!clickExpandBtn);
                    }}
                  />
                )}
            </div>
          </div> */}
          <div className="my-2 d-flex align-items-center justify-content-between">
            {queries?.status === "pending" ? (
              <div style={{ marginRight: "2.5rem" }} className="d-flex">
                <div
                  className="mr-2 edit_query_box"
                  onClick={(e) => setChangeStatus("rejected")}
                >
                  <img src="/images/Cancle.svg" alt="delete icon" />
                  <span
                    className="ml-1 edit_query"
                    id={queries?.id}
                    name="rejected"
                  >
                    Decline
                  </span>
                </div>
                <div
                  className="delete_query_box"
                  onClick={(e) => setChangeStatus("approved")}
                >
                  <img src="/images/Check.svg" alt="delete icon" />
                  <span
                    className="ml-1 delete_query"
                    id={queries?.id}
                    name="approved"
                  >
                    Activate
                  </span>
                </div>
              </div>
            ) : (
              user &&
              !(
                queries?.status === "resolved" || queries?.status === "rejected"
              ) && <></>
            )}
          </div>
          <div className="d-flex mt-2 ">
            {attachments?.length > 0 &&
              attachments?.map((attachment, index) => (
                <div key={index}>
                  {attachment.split(".").pop() !== "mp4" ? (
                    <div
                      className="flex query_attach_box align-items-center py-2 px-3 mr-2 mb-2"
                      onClick={() => {
                        const fileType = attachment.split(".").pop();
                        if (
                          fileType === "jpg" ||
                          fileType === "jpeg" ||
                          fileType === "png" ||
                          fileType === "mp4" ||
                          fileType === "JPG" ||
                          fileType === "JPEG" ||
                          fileType === "PNG" ||
                          fileType === "MP4"
                        ) {
                          handleClick(attachment);
                        } else if (
                          fileType === "pdf" ||
                          fileType === "PDF" ||
                          fileType === "ppt" ||
                          fileType === "PPT" ||
                          fileType === "PPTX" ||
                          fileType === "pptx"
                        ) {
                          handleClickforpdf(attachment);
                        }
                      }}
                    >
                      <>
                        {attachment.split(".").pop() === "jpg" ||
                          attachment.split(".").pop() === "jpeg" ||
                          attachment?.split(".").pop() === "JPEG" ||
                          attachment?.split(".").pop() === "JPG" ||
                          attachment?.split(".").pop() === "PNG" ||
                          attachment?.split(".").pop() === "mp4" ||
                          attachment?.split(".").pop() === "MP4" ||
                          attachment.split(".").pop() === "png" ? (
                          <div
                            // key={index}
                            onClick={() => {
                              if (!isError) {
                                handleClick(attachment);
                              }
                            }}
                            className="d-flex gap-2 p-1"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                style={{ maxHeight: "19px" }}
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment.substring(
                                      attachment.lastIndexOf(".") + 1
                                    )
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center pdf_logo"
                            onClick={() => handleClickforpdf(attachment)}
                          >
                            <img
                              className="attachLogoActivity w-4"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                        )}
                      </>
                      &nbsp;&nbsp;
                      {getAttachmentName(attachment)}
                      &nbsp;
                      <span style={{ color: "#677489" }} className=" me-2">
                        {/* (45kb) */}
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex pdfContainer gap-2 p-2 " onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}>
                      <div className="d-flex align-items-center w-5">
                        <img
                          className="extention_icon"
                          src={`${iconData?.find(
                            (i) =>
                              i.extension ===
                              attachment?.match(/\.([^.]+)$/)[1]
                          )?.icon
                            }`}
                          alt=""
                        />
                      </div>
                      <div className="w-100">
                        <div className="pdfName">
                          {/* {attachment?.replace(/^[^_]*_/, "")} */}
                          {getAttachmentName(attachment)}
                        </div>
                        <div className="pdfFileSize"></div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>


          {clickExpandBtn && queries?.status !== "pending" && (
            <div className="d-flex justify-content-end">
              <div className="d-flex justify-content-end mt-3 ml-3">
                <button
                  className="refetch mr-3"
                  onClick={() => {
                    setReply([]);
                    getReplyReload();
                    setIsPreventApiCall(true)
                  }}
                >
                  Refresh
                </button>
                <div className="search_container search_reply d-flex align-items-center ">
                  <div className="d-flex align-items-center">
                    <img
                      onClick={() => {
                        setOption("Name");
                        setFilter({
                          ...filter,
                          replyText: "",
                          date: "",
                          page: 1,
                        });
                      }}
                      className="ml-2"
                      src={`/images/${option !== "Name" ? "reply_name" : "orange_reply_name"
                        }.png`}
                      alt=""
                    />
                    <img
                      onClick={() => {
                        setOption("Date");
                        setFilter({
                          ...filter,
                          replyText: "",
                          date: "",
                          page: 1,
                        });
                      }}
                      className="ml-2"
                      src={`/images/${option !== "Date"
                        ? "reply_calender"
                        : "orange_reply_calender"
                        }.png`}
                      alt=""
                    />
                    <span style={{ color: "#CCD6DD" }} className="ml-2">
                      |
                    </span>
                  </div>
                  <div className="reply_search_input">
                    {option === "Date" ? (
                      // <input
                      //   type="date"
                      //   name="date"
                      //   value={filter.date}
                      //   className="reply_calendar_box search_calendar_Box"
                      //   onKeyDown={(e) => handleKeyDown(e)}
                      //   onChange={(e) =>
                      //     setFilter({
                      //       ...filter,
                      //       replyText: null,
                      //       date: e.target.value,
                      //       page: 1,
                      //     })
                      //   }
                      // />
                      <DatePicker
                        selected={filter.date}
                        placeholderText="MM/DD/YYYY"
                        onChange={(e) => {
                          formatDate(e);
                          // setReply([]);
                          setFilter({
                            ...filter,
                            replyText: null,
                            date: e,
                            page: 1,
                          });
                        }}
                        className="search_calendar_Box1"
                        onKeyDown={(e) => handleKeyDown(e)}
                      />
                    ) : (
                      <input
                        type="text"
                        value={filter.replyText}
                        className="reply_search_box search_boxs"
                        placeholder="Search in query..."
                        onKeyDown={(e) => handleKeyDown(e)}
                        onChange={(e) => {
                          // setReply([]);
                          setFilter({
                            ...filter,
                            date: null,
                            page: 1,
                            replyText: e.target.value,
                          });
                        }}
                      />
                    )}
                  </div>
                  {(filter.replyText || filter.date) ? (
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon"
                      style={{ opacity: 1, cursor: 'pointer' }} // Icon enabled (clickable)
                      alt="Search"
                      onClick={() => {
                        setReply([]); // Clear the reply list before search
                        setFilter({
                          ...filter,
                          searchClick: !filter.searchClick, // Trigger the search by toggling searchClick
                        });
                      }}
                    />
                  ) : (
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon"
                      style={{ opacity: 0.5, cursor: 'not-allowed' }}
                      alt="Search"
                    />
                  )}
                </div>
                {clickExpandBtn && queries?.status !== "pending" && (
                  <p
                    style={{
                      margin: "4px 15px",
                      color: "#f88409",
                      fontWeight: "500",
                      fontSize: "14px",
                      textDecoration: "underline",
                      width: "8%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setFilter({
                        date: null,
                        // tag: "",
                        // name: "",
                        // status: "all",
                        // sortBy: -1,
                        // time: null,
                        // limit: Infinity,
                        // page: 1,
                        searchClick: false,
                        replyText: ""
                      });
                      setReply([]);
                      setIsClearingSearch(true)
                      getReplyReload()
                      setIsPreventApiCall(true)
                    }}
                  >
                    Clear Search
                  </p>
                )}
              </div>
            </div>
          )}
          {pedingSubDetail.pdfView && (
            <PdfViewer
              handleRemovePdfVivwer={handleRemovePdfVivwer}
              attachment={responseAttach}
            />
          )}
          {isClicked &&
            (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
              <div className="fullSizeImg ">
                <div className="SubfullSizeImg">
                  <video className="videoPlayer" controls>
                    <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                  </video>
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/DCM-img/crossIcon.svg"
                      alt="Up Arrow"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="fullSizeImg ">
                <div className="SubfullSizeImg">
                  {
                    !isError ? (
                      <>
                        <img
                          className="imgMain"
                          src={IP + responseAttach?.replace(/^\./, "")}
                          alt="Full-size"
                          onError={(e) => {
                            setIsError(true)
                          }}
                        />
                        <div>
                          <img
                            className="crossIconImgQue"
                            onClick={handleClick}
                            src="/images/cross.png"
                            alt="Up Arrow"
                          />
                        </div>
                      </>
                    ) : (
                      <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                        <img
                          onClick={() => {
                            setIsError(false)
                            handleClick()
                          }}
                          src="/images/cross.png"
                          alt="Up Arrow"
                          style={{ position: "absolute", top: "75px", right: "40%" }}
                        />
                        <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                        <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                      </div>
                    )
                  }
                </div>
              </div>
            ))}
        </div>
        {/* {mideaviewer && (
          <MideaViewer
            closeMideaviewer={() => setMideaviewer(!mideaviewer)}
            attachment={mideaviewerAttachment}
          />
        )} */}
        {clickExpandBtn && (
          <ReplyQuery
            id={reply.length}
            filter={filter}
            setFilter={setFilter}
            reply={reply}
            queries={queries}
            setReply={setReply}
            queryStatus={queries?.status}
            queryId={queries?.id}
            replyfetch={replyfetch}
            setReplyFetch={setReplyFetch}
            date1={selectedDate}
            arrowFetch={clickExpandBtn}
            groupData={groupData}
            isGettingReply={isGettingData}
            isClearingSearch={isClearingSearch}
            isPreventApiCall={isPreventApiCall}
          />
        )}
        {deleteQuery && (
          <DeleteQuery
            reload={refetch}
            setDelQuery={setDelQuery}
            setDeleteQuery={setDeleteQuery}
            setQuery={setQuery}
            queryId={queries.id}
          />
        )}
        {/* {markQuery && (
          <ResolveQuery
            setQuery={setQuery}
            setDelQuery={setDelQuery}
            setExpandQuery={setExpandQuery}
            setDataFinal={setDataFinal}
            setMarkQuery={setMarkQuery}
            queryId={queries.id}
          />
        )} */}
        {changeStatus && (
          <DeclineQuery
            queryStatus={changeStatus}
            setChangeStatus={setChangeStatus}
            setQuery={setQuery}
            queryId={queries.id}
          />
        )}
      </div>
    </>
  );
};

export default QueryExpand;
